/**
 * Tour styles — conditionally themed for dark/light mode,
 * consistent with Ant Design's design system.
 */
export function getTourStyles(isDark: boolean) {
  return {
    popover: (base: Record<string, unknown>) => ({
      ...base,
      backgroundColor: isDark ? '#1f1f1f' : '#ffffff',
      color: isDark ? 'rgba(255,255,255,0.88)' : 'rgba(0,0,0,0.88)',
      borderRadius: 12,
      padding: '24px 28px',
      boxShadow: isDark
        ? '0 8px 32px rgba(0,0,0,0.48)'
        : '0 8px 32px rgba(31,75,216,0.14)',
    }),
    badge: (base: Record<string, unknown>) => ({
      ...base,
      backgroundColor: '#1f4bd8',
      color: '#fff',
      fontWeight: 600,
    }),
    controls: (base: Record<string, unknown>) => ({
      ...base,
      marginTop: 16,
    }),
    button: (base: Record<string, unknown>) => ({
      ...base,
      backgroundColor: '#1f4bd8',
      color: '#fff',
      borderRadius: 8,
      border: 'none',
      padding: '6px 16px',
      cursor: 'pointer',
    }),
    arrow: (base: Record<string, unknown>, state?: Record<string, unknown>) => ({
      ...base,
      color: (state as { disabled?: boolean })?.disabled
        ? (isDark ? 'rgba(255,255,255,0.22)' : 'rgba(0,0,0,0.18)')
        : '#ffffff',
      cursor: (state as { disabled?: boolean })?.disabled ? 'not-allowed' : 'pointer',
    }),
    // close: não utilizado — botão substituído por TourCloseButton em App.tsx
    dot: (base: Record<string, unknown>, state?: Record<string, unknown>) => ({
      ...base,
      backgroundColor:
        (state as { current?: boolean }).current
          ? '#1f4bd8'
          : isDark
          ? 'rgba(255,255,255,0.2)'
          : 'rgba(0,0,0,0.2)',
    }),
    maskArea: (base: Record<string, unknown>) => ({ ...base, rx: 8 }),
  };
}
